import counts from './counts.generated.json';

// Генерируется перед dev/build: меню не должно импортировать полные карточки товаров.
const COUNTS: Readonly<Record<string, number>> = counts;

export const getCategoryItemCount = (slug: string): number | undefined =>
  Object.hasOwn(COUNTS, slug) ? COUNTS[slug] : undefined;
